"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchReadableStreamTransport = void 0;
var debug = console.debug;
function fromFetchHeaders(hd) {
    var mt = {};
    hd.forEach(function (v, k) { return (mt[k] = v); });
    return mt;
}
function FetchReadableStreamTransport() {
    return function (opts) { return new Fetch(opts); };
}
exports.FetchReadableStreamTransport = FetchReadableStreamTransport;
var Fetch = (function () {
    function Fetch(opts) {
        this.cancelled = false;
        this.controller = self.AbortController && new AbortController();
        this.options = opts;
        this.credentials = opts.withCredentials ? 'include' : 'same-origin';
    }
    Fetch.prototype.sendMessage = function (msgBytes, metadata) {
        var _this = this;
        var headers = new Headers();
        Object.keys(metadata).forEach(function (k) { return headers.set(k, metadata[k]); });
        fetch(this.options.url, {
            credentials: this.credentials,
            headers: headers,
            method: 'POST',
            body: msgBytes,
            signal: this.controller && this.controller.signal,
        })
            .then(function (res) {
            var _a;
            _this.options.debug && debug('Fetch.response', res);
            _this.options.onHeaders(fromFetchHeaders(res.headers), res.status);
            if (!res.ok) {
                throw new Error("HTTP " + res.status + " - " + res.statusText);
            }
            if (_this.cancelled) {
                (_a = res.body) === null || _a === void 0 ? void 0 : _a.cancel();
            }
            else {
                return res
                    .arrayBuffer()
                    .then(_this.options.onChunk)
                    .then(function () { return _this.options.onEnd(); });
            }
        })
            .catch(function (err) {
            _this.options.debug && debug('Fetch.catch', err.message);
            _this.options.onEnd(err);
        });
    };
    Fetch.prototype.cancel = function () {
        var _a;
        if (!this.cancelled) {
            this.cancelled = true;
            (_a = this.controller) === null || _a === void 0 ? void 0 : _a.abort();
            this.options.debug && debug('Fetch.cancel controller abort');
        }
    };
    return Fetch;
}());
